<section
  [ngClass]="{
    'view--public': note.state === 'PUBLIC',
    'view--draft' : note.state === 'HIDDEN',
    'view--inline': view === 'list',
    'view--inline--newsletter': view === 'list-newsletter',
    'view--inline--saved-notes': view === 'list-saved-notes'
  }"
  class="note-wrapper">
  <img-lazy-loading
    class="note-wrapper__side-thumbnail-img"
    *ngIf="note && note.thumbnailMeta && note.thumbnails && note.thumbnailImage"
    [url]="note.shortURLPath ? ['/n', note.shortURLPath] : ['/notes', note.id, note.indexedName || note.name || note.id]"
    [mainThumb]="note.thumbnailImage"
    [customSizes]="'(min-width: 701px) 30vw, (max-width: 700px) 80vw, 90vw'"
    [thumbs]="note.thumbnails"
    [title]="'Read more about ' + note.name"></img-lazy-loading>
  <a
    class="note-wrapper__add-thumb-wrapper"
    *ngIf="note && note.userId && currentLoggedUser && currentLoggedUser.id && currentLoggedUser.id.toString() === note.userId.toString() && !note.thumbnails"
    (click)="showThumbModal()">
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19,13a1,1,0,0,0-1,1v.38L16.52,12.9a2.79,2.79,0,0,0-3.93,0l-.7.7L9.41,11.12a2.85,2.85,0,0,0-3.93,0L4,12.6V7A1,1,0,0,1,5,6h7a1,1,0,0,0,0-2H5A3,3,0,0,0,2,7V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V14A1,1,0,0,0,19,13ZM5,20a1,1,0,0,1-1-1V15.43l2.9-2.9a.79.79,0,0,1,1.09,0l3.17,3.17,0,0L15.46,20Zm13-1a.89.89,0,0,1-.18.53L13.31,15l.7-.7a.77.77,0,0,1,1.1,0L18,17.21ZM22.71,4.29l-3-3a1,1,0,0,0-.33-.21,1,1,0,0,0-.76,0,1,1,0,0,0-.33.21l-3,3a1,1,0,0,0,1.42,1.42L18,4.41V10a1,1,0,0,0,2,0V4.41l1.29,1.3a1,1,0,0,0,1.42,0A1,1,0,0,0,22.71,4.29Z" fill="#6563ff"/></svg>
    <span class="stream-details__add-thumb-wrapper__title">Click here to upload your note thumbnail</span>
  </a>
  <image-editor
    *ngIf="note && note.userId && currentLoggedUser && currentLoggedUser.id && currentLoggedUser.id.toString() === note.userId.toString() && !note.thumbnails"
    (uploaded)="setNoteThumbnail($event)"
    [onlyModal]="true">
  </image-editor>
  <div class="note-wrapper__details">
    <a
      *ngIf="removeNoteButton"
      (click)="removeFromList(note)"
      data-cy="remove-button"
      class="note-wrapper__remove-button" [title]="removeNoteButton.title">
      <svg id="Capa_1" enable-background="new 0 0 413.348 413.348" height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/></svg>
    </a>
    <h2 class="note-wrapper__title">
      <a class="note-wrapper__title__link"
        (click)="loadingNoteRoute = true"
        [routerLink]="note.shortURLPath ? ['/n', note.shortURLPath] : ['/notes', note.id, note.indexedName || note.name || note.id]" [title]="note.name">{{note.name}}</a>
      <div class="note-wrapper__title__user-links" *ngIf="ownnedNote || editNoteAllowed">
        <button 
          class="notd__button--v2" 
          [title]="'Edit your note'" 
          [routerLink]="['/note', note.id]" 
          [queryParams]="saveReturnUrl ? { saveReturnUrl: saveReturnUrl } : null">
          Edit
        </button>
        <button
          class="notd__button--v2"
          [title]="'Delete this note'"
          *ngIf="canDeleteNote"
          (click)="deleteNote()">Delete</button>
      </div>
      <div
        *ngIf="!ownnedNote && note.pinned"
        class="note-wrapper__title__other-actions">
        <svg
          *ngIf="note.pinned"
          class="note-wrapper__title__other-actions__pinned"
          enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m330.274 0-10.607 10.607c-24.914 24.914-28.585 63.132-11.047 91.987l-107.305 72.504-1.856-1.856c-40.939-40.939-107.553-40.94-148.492 0l-10.607 10.606 133.289 133.289-173.649 173.65 21.213 21.213 173.649-173.65 133.29 133.29 10.607-10.607c40.94-40.94 40.939-107.553 0-148.492l-1.856-1.856 72.504-107.305c28.855 17.539 67.073 13.868 91.987-11.047l10.606-10.606zm-3.187 428.148-243.235-243.235c29.104-19.248 68.783-16.069 94.394 9.541l139.3 139.3c25.61 25.611 28.789 65.29 9.541 94.394zm-11.791-139.07-92.374-92.374 105.496-71.281 58.159 58.159zm101.245-117.958-75.66-75.66c-13.828-13.828-16.758-34.491-8.789-51.216l135.665 135.665c-16.725 7.969-37.388 5.039-51.216-8.789z"/></g></svg>
      </div>
    </h2>
    <div class="note-wrapper__tags" *ngIf="noteTags.length > 0">
      <a
        [routerLink]="['/search/query/notes', tag.code]"
        class="note-wrapper__tags__tag" title="{{tag.label}}" *ngFor="let tag of noteTags">{{tag.label}}</a>
    </div>
    <div class="note-wrapper__writer">
      <a
        class="by-user"
        [ngClass]="{'stream-info-added': showStreamName}"
        [routerLink]="['/user', noteOwner.userName || note.userId, 'profile']"
        [title]="'Visit ' + (noteOwner.displayName || noteOwner.userDisplayName) + ' profile!'"
        *ngIf="noteOwner">
        <img-lazy-loading
          class="avatar"
          *ngIf="noteOwner && noteOwner.profileImageUrl"
          [mainThumb]="noteOwner.profileImageUrl"
          [thumbs]="noteOwner.profileImgThbs"></img-lazy-loading>
        {{noteOwner.displayName ? noteOwner.displayName : noteOwner.userDisplayName}}
      </a>
      <div class="stream-user-info"
        *ngIf="showStreamName">
        <span class="text-in">in</span>
        <span
          *ngIf="note && note.channel"
          class="stream-name"
          [title]="'Visit ' + note.channel.name + ' stream!'"
          [routerLink]="(note.channel && note.channel.shortURLPath) ? ['/s', note.channel.shortURLPath] : ['/streams', note.channelId, 'view', note.channel.indexedName || note.channel.name || note.channel.id]">
          {{note.channel.name}}
        </span>
      </div>
      <span class="date">{{note.published || note.created | date: 'MMM dd, yyyy' }}</span>
    </div>
    <div class="note-wrapper__other-tags" *ngIf="note.pinned || note.state === 'HIDDEN' || fileAudioIncluded || note.price === 0">
      <span class="note-wrapper__other-tags__tag tag--free-note" *ngIf="note.price === 0">free note</span>
      <span class="note-wrapper__other-tags__tag tag--draft" *ngIf="note.state === 'HIDDEN'">draft</span>
      <span class="note-wrapper__other-tags__tag tag--draft" *ngIf="note.pinned">pinned</span>
      <span class="note-wrapper__other-tags__tag tag--audio" *ngIf="fileAudioIncluded">
        <fa-icon [icon]="['fas', 'volume-up']"></fa-icon>
        Audio file included
      </span>
    </div>
    <div class="note-wrapper__content">
      <div class="note-wrapper__content__current" *ngIf="getLeadWords()">
        <img-lazy-loading
          class="note-wrapper__content__current__thumbnail-img"
          *ngIf="note && note.thumbnailMeta && note.thumbnails && note.thumbnails"
          [url]="note.shortURLPath ? ['/n', note.shortURLPath] : ['/notes', note.id, note.indexedName || note.name || note.id]"
          [mainThumb]="note.thumbnailImage"
          [thumbs]="note.thumbnails"
          [title]="'Read more about ' + note.name"></img-lazy-loading>
        <div
          class="note-wrapper__content__current__text"
          [innerHTML]="getLeadWords()"
          limitToCharacters
          [limit]="1000"></div>
        <div class="note-wrapper__content__current__read-more">
          <a
            class="note-wrapper__content__current__read-more__link notd__button--v2"
            [routerLink]="note.shortURLPath ? ['/n', note.shortURLPath] : ['/notes', note.id, note.indexedName || note.name || note.id]" [title]="'Read more about ' + note.name">Read more</a>
        </div>
      </div>
      <div *ngIf="!getLeadWords()" class="note-wrapper__content__no-content">
        <p>This note has no premium content</p>
      </div>
    </div>
  </div>
  
</section>
